import { TIME_STAMP } from 'constants/AuthConstant';
import rootReducer from './rootReducer';
import { configureStore } from '@reduxjs/toolkit';


const middlewares = [];


const expirationTime = 24 * 60 * 60 * 1000;
localStorage.setItem(TIME_STAMP, Date.now());


const itemTimestamp = localStorage.getItem(TIME_STAMP);
if (itemTimestamp && Date.now() - itemTimestamp > expirationTime) {
  localStorage.clear();
};


const store = configureStore({
	reducer: rootReducer(),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(middlewares),
	devTools: process.env.NODE_ENV === 'development',
});


store.asyncReducers = {};


export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return false;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(rootReducer(store.asyncReducers));
	return store;
};


export default store;